import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

function ScrollTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="माथि जानुहोस्"
      title="माथि जानुहोस्"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-crimson text-white shadow-xl flex items-center justify-center hover:bg-crimson-dark hover:-translate-y-0.5 transition-all"
    >
      <ArrowUp size={22} />
    </button>
  );
}

export default ScrollTopButton;
